import React, { Component } from "react"
import MetaTags from 'react-meta-tags';

import { format } from 'date-fns';
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardHeader,
  CardTitle,
  FormGroup,
  Label,
  Button,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Breadcrumb,
  BreadcrumbItem,
 

} from "reactstrap";
import Select from "react-select";
import axios from 'axios';
import  { Redirect } from 'react-router-dom';
// import $ from "jquery";
import ModalMessage from "../pages/messages/ModalMessage"
import Flatpickr from "react-flatpickr";
import { French } from "flatpickr/dist/l10n/fr.js";
import ReactSelect from 'react-select';
import makeAnimated from 'react-select/animated';
//import BootstrapSelect from "bootstrap-select"
import url from "../../common/api"
import {getLanguageList} from "../../services/langueService.js"
import {getThematiqueList} from "../../services/thematiqueService.js"
import {getCategorieList} from "../../services/categorieService.js"
import {getFormatList} from "../../services/formatService.js"
import {getTypeSystemeIrrigueList} from "../../services/systemeIrrigueService.js"
import {getStructureList} from "../../services/structureService.js"
import {getSpecialiteList} from "../../services/specialiteService.js"
import {getMotCleList} from "../../services/motCleService.js"
import {getTypeExpertList} from "../../services/typeExpertService.js"
import {getPaysList} from "../../services/paysService.js"
import {getQueries} from "../../queries/getQueries.js"
import {postQueries} from "../../queries/postQueries.js"
import validator from 'validator'
class AjoutExpert extends Component {

  constructor(props) {
    super(props)
    this.state = {
      ok:"",
      langue:[],
      localisation:[],
      structure:[],
      motcle:[],
      specialite:[],
      categorie:[],
      thematique:[],
      irrigue:[],
      type_expert:[],
      sous_type_expert:[],
      profiles_attributes:[],
      langues_attributes:[],
      specialites_attributes:[],
      sous_type_expert_attributes:[],
      pays_attributes:[],
      systeme_attributes:[],
      thematiques_attributes:[],
      mots_attributes:[],
      public_id:0,
      profile:[],
      show:false,
      success:true,
      video:"",
      message:"Acteur ajouté avec succès !",
      titre:"Message ajout de acteur",
      boutton:"OK",
      input: {},
      errors: {},
      emailError:"", 
      setEmailError:"",
      block_acces:false,
      personalite:true
    }
    this.handleChangeLocalisation.bind(this);
    this.handleChangeLangue.bind(this);
    this.handleChangeUnite.bind(this);
    this.handleChangeSysteme.bind(this);
    this.handleChangeSpecialite.bind(this);
    this.handleChangeThematique.bind(this);
   // this.handleChangeProfile.bind(this);
    this.onChangeBlocAcces.bind(this);
    // this.handleErrorTypeExpert.bind(this)
    this.handleErrorNom.bind(this)
    this.handleErrorPrenom.bind(this)
    this.handleErrorAdresse.bind(this)
    // this.handleChangeSousTypeExpert.bind(this)
  }

  componentDidMount() {
    sessionStorage.setItem("sis-session",900000)
    $("#chargement").hide()
    $("#echecSauv").hide()
    $("#profile").hide()
    $("#valideFile").hide()
    
    //Tooltips
    $(function () {
      $('[data-toggle="tooltip"]').tooltip()
    })
    getTypeExpertList().then(e=>this.setState({type_expert:e}))
    getLanguageList().then(e=>this.setState({langue:e}))
    getPaysList().then(e=>this.setState({localisation:e}))
    getStructureList().then(e=>this.setState({structure:e}))
    getMotCleList().then(e=>this.setState({motcle:e}))
    getFormatList().then(e=>this.setState({format:e}))
    getTypeSystemeIrrigueList().then(e=>this.setState({irrigue:e}))
    getSpecialiteList().then(e=>this.setState({specialite:e}))
    getCategorieList().then(e=>this.setState({categorie:e}))
    getThematiqueList().then(e=>this.setState({thematique:e}))

    // getQueries("profiles").then(e=>{
    //   const data=e
    //   try{
    //     this.setState({public_id:data.filter(x => (x.libelle).toLowerCase() === ("Public").toLowerCase())[0].id,
    //    // profiles_attributes:[{"profile_id":data.filter(x => (x.libelle).toLowerCase() === ("Public").toLowerCase())[0].id}]
    //   })
        
    //    }catch(error){
  
    //    }

    //    data.filter(x => (x.libelle).toLowerCase() != ("Public").toLowerCase()).map((element,idx) =>{
    //     this.setState({profile:[...this.state.profile,{value:element.id,label:element.libelle}]})
    //   })

    // })

  }


  handleCreer=()=>{

    // Vérification email
    // this.handleErrorEmail
   const profile_id=JSON.parse(sessionStorage.getItem("authAshia")).profile.id

    if(this.validate()){
      console.log(this.state);

      let input = {};
      input["name"] = "";
      input["email"] = "";
      input["comment"] = "";
      this.setState({input:input});

      // alert('Demo Form is submited');
    }

    var date=new Date();
    const NewDate= format(date,'dd/MM/yyyy');
    const mot=_.uniqBy(this.state.mots_attributes, 'mot_cle_id')
    $("#initial").hide()
    $("#chargement").show()

    var data= {
      "nom": $("#nom").val(), 
      "prenom": $("#prenom").val(),
      "adresse": $("#adresse").val(),
      "email":$("#email").val(),
      "fonction":"EXPERT",
      "telephone":$("#telephone").val(),
      "password": $("#pwd1").val(),
      "status":$("#statut option:selected").val(),
      "structure_id":$("#structure_id option:selected").val()!=="0"?$("#structure_id option:selected").val():null,
      "type_expert_id":$("#type_expert_id option:selected").val(),
      "profile_id":profile_id,
      "utilisateur_langues_attributes":this.state.langues_attributes,
      "utilisateur_pays_attributes":this.state.pays_attributes,
      "utilisateur_type_s_irrigues_attributes":this.state.systeme_attributes,
      "utilisateur_thematiques_attributes":this.state.thematiques_attributes,
      "utilisateur_specialites_attributes":this.state.specialites_attributes,
      "expert_sous_types_attributes":this.state.sous_type_expert_attributes,
      
    }
    console.log("donnee transmises:",data)

    if((($("#pwd1").val()=="" || $("#pwd2").val()=="" )) && this.state.block_acces){
      $("#initial").show()
      $("#chargement").hide()
      $("#pwd2").val("")
      $("#pwd1").val("")
      this.setState({message:"Vous devez saisir votre mot de passe"})
      this.setState({show:true,success:false});
    }else{

      if((($("#pwd1").val()!==$("#pwd2").val()) ) && this.state.block_acces){
        $("#initial").show()
        $("#chargement").hide()
        $("#pwd2").val("")
        $("#pwd1").val("")
        this.setState({message:"Veuillez saisir des mot de passe identiques"})
        this.setState({show:true,success:false});
      }else{
          if(($("#type_expert_id option:selected").val()=="0") || ($("#nom").val()=="") || ( ($("#prenom").val()=="") && this.state.personalite )){
            $("#initial").show()
            $("#chargement").hide()
    
            this.setState({message:"Veuillez renseigner les champs obligatoires !"})
            this.setState({show:true,success:false});
          }
          else{
            postQueries("utilisateurs",data).then(e=>{
              if(e){
              $("#initial").show()
              $("#chargement").hide()
              console.log("ressorce ok",e) 
    
              this.setState({message:"Ajout d'acteur effectué avec succès !"})
              this.setState({show:true,success:true});
              }else{
              $("#initial").show()
              $("#chargement").hide()
              this.setState({message:"Une Erreur est survenue lors de la sauvegarde. Veuillez Reéssayer plutard !"})
              this.setState({show:true,success:false});
              }
            
            })
          }
        }

    }
    
    
  }



  handleValidate=()=>{
    if(this.state.success){
      this.setState({ok: <Redirect to='/liste-expert'/>});
    }else{
      this.setState({show:false})
    }
    
  }



  handleAnnuler=()=>{
    this.setState({ok: <Redirect to='/liste-expert'  />});
  }

  handleChangeLocalisation = (e) => {
   
    var data=[]
    this.setState({pays_attributes:data,unite:data})
    var localisation=[]
    var unite=[]
    try{


    e.map((element,idx) =>{
      
      
      localisation=[...localisation,{"pay_id":element.value}]

      this.setState({pays_attributes:localisation})
      
    })
    
  } catch(e){
    this.setState({pays_attributes:data,unite:data,unites_attributes:data})
  }
  }

  handleChangeLangue = (e) => {
    var data=[]
    this.setState({langues_attributes:data})
    try{
      e.map((element,idx) =>{
        this.setState({langues_attributes:[...this.state.langues_attributes,{"langue_id":element.value}]})
      })
    }catch(error){
      this.setState({langues_attributes:data})
    }   
  }
  handleChangeThematique = (e) => {
    var data=[]
    this.setState({thematiques_attributes:data})
    try{
      e.map((element,idx) =>{
        this.setState({thematiques_attributes:[...this.state.thematiques_attributes,{"thematique_id":element.value}]})
      })
    }catch(error){
      this.setState({thematiques_attributes:data})
    }
   
  }
  handleChangeUnite = (e) => {
    var data=[]
    this.setState({unites_attributes:data})
    try{
      e.map((element,idx) =>{
        this.setState({unites_attributes:[...this.state.unites_attributes,{"unite_administrative_id":element.value}]})
      })
    }catch(error){
      this.setState({unites_attributes:data})
    }
   
  }
  handleChangeSpecialite = (e) => {
    var data=[]
    this.setState({specialites_attributes:data})
    this.handleChangeNew
    try{
      e.map((element,idx) =>{
        this.setState({specialites_attributes:[...this.state.specialites_attributes,{"specialite_id":element.value}]})
        })
    }catch(error){
      this.setState({specialites_attributes:data})
    }
  }

  handleChangeSousTypeExpert=(e)=>{

    var data=[]
    this.setState({sous_type_expert_attributes:data})
    try{
      e.map((element,idx) =>{
        this.setState({sous_type_expert_attributes:[...this.state.sous_type_expert_attributes,{"sous_type_expert_id":element.value}]})
      })
    }catch(error){
      this.setState({sous_type_expert_attributes:data})
    }

  }

  handleChangeNew = function (newValue, actionMeta) {
    console.group('Value Changed');
    console.log(newValue);
    console.log("action: " + actionMeta.action);
    console.groupEnd();
  };


  handleChangeSysteme = (e) => {
    var data=[]
    this.setState({systeme_attributes:data})
    try{
      e.map((element,idx) =>{
        this.setState({systeme_attributes:[...this.state.systeme_attributes,{"type_systeme_irrigue_id":element.value}]})
      })
    }catch(error){
      this.setState({systeme_attributes:data})
    }
    
  }

  


  handleErrorNom=(e)=>{
    if(e.target.value!=0){
      $("#valideNom").hide()
      $("#nom").removeClass("is-invalid")
      $("#echecSauv").hide()
    }else{
      $("#valideNom").show()
      $("#nom").addClass("is-invalid")
    }
  }
  handleErrorPrenom=(e)=>{
    if(e.target.value!=0){
      $("#validePrenom").hide()
      $("#prenom").removeClass("is-invalid")
      $("#echecSauv").hide()
    }else{
      $("#validePrenom").show()
      $("#prenom").addClass("is-invalid")
    }
  }
  handleErrorEmail=(e)=>{
    var email = e.target.value
    if(validator.isEmail(email)) {
      $("#valideEmail").hide()
      $("#email").removeClass("is-invalid")
      $("#echecSauv").hide()
    }else{
      $("#email").addClass("is-invalid")
      $("#valideEmail").show()
    }
  }
  handleErrorAdresse=(e)=>{
    if(e.target.value!=0){
      $("#valideAdresse").hide()
      $("#adresse").removeClass("is-invalid")
      $("#echecSauv").hide()
    }else{
      $("#valideAdresse").show()
      $("#adresse").addClass("is-invalid")
    }
  }
  
  handleFindSousTypeActeur=(e)=>{
    var type=[]
    this.state.type_expert.find(val=>val.value==e)?.sous_types.map((el)=>{
      type=[...type,{value:el.id,label:el.libelle}]
      this.setState({sous_type_expert:type})
    })
  }

  handleErrorTypeExpert=(e)=>{
    var data=[]
    var type=[]
    this.setState({sous_type_expert:data})
    if(e.target.value!=0){
      this.setState({sous_type_expert:data})
   
      setTimeout(()=>
           {this.handleFindSousTypeActeur(e.target.value)}
    , 100)
      

      $("#valideTypeExpert").hide()
      $("#type_expert_id").removeClass("is-invalid")
      $("#echecSauv").hide()
    }else{
      this.setState({sous_type_expert:data})
      $("#valideTypeExpert").show()
      $("#type_expert_id").addClass("is-invalid")
    }
  }
  
  onChangeBlocAcces=(e)=>{
    
    this.setState({block_acces:$('.chbx').is(':checked')})
  }

  validate(){
    let input = this.state.input;
    let errors = {};
    let isValid = true;

    // if (!input["email"]) {
    //   isValid = false;
    //   errors["email"] = "Please enter your email Address.";
    // }

    if (typeof input["email"] !== "undefined") {
      var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
      if (!pattern.test(input["email"])) {
        isValid = false;
        errors["email"] = "Please enter valid email address.";
      }
    }

    this.setState({
      errors: errors
    });

    return isValid;
  }
  render() {

    const { pick } = this.state
    const animatedComponents = makeAnimated();
    const type_personalite=[{label:"Personne morale",value:false},{label:"Personne physique",value:true}]

    return (
      <React.Fragment>
        <div className="page-content">   {this.state.ok}

        <ModalMessage
              show={this.state.show}
              success={this.state.success}
              boutton={this.state.boutton}
              handleValidate={this.handleValidate}
              message={this.state.message}
              titre={this.state.titre}
              onCloseClick={() => this.setState({ show: false })}
              />

        <MetaTags>
            <title>Ajouter un acteur de l 'irrigation</title>
        </MetaTags>
        <Container fluid={true}>
            <Row>
              <Col md="8">
                  <div className="page-title-box d-flex align-items-center justify-content-between">
                  <h4 className="mb-0 font-size-18">Nouvel acteur de l 'irrigation</h4>
                  </div>
              </Col>
            </Row>

            <hr/>

            <Card style={{borderRadius:"25px",borderColor:"#AAD29A",borderWidth:"5px"}}>
              <CardBody>
              <h4 className="text-center mt-2">Description de l'acteur</h4>
              <hr/>
              <Row className="mt-4"> 
                <Col md="4">
                  <label>Type de personne</label>
                  <ReactSelect
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    // isMulti
                    onChange={e=>this.setState({personalite:e.value})}
                    options={type_personalite}
                    placeholder="Personne physique"
                  />
                </Col>
                {
                  !this.state.personalite?
                    <Col md="8">
                       <label>Nom</label>
                      <Input
                        onChange={this.handleErrorNom}
                        className="form-control is-invalid"
                        type="text"
                        id="nom"
                        placeholder="Nom"
                      />
                      <div id="valideNom" class="invalid-feedback">
                        Svp veuillez renseigner le nom de l'acteur.
                      </div>
                    </Col>:null

                }
              </Row>
              {
              this.state.personalite?
                <Row className="mt-4"> 
                  <Col md="4">
                    <label>Nom</label>
                    <Input
                      onChange={this.handleErrorNom}
                      className="form-control is-invalid"
                      type="text"
                      id="nom"
                      placeholder="Nom"
                    />
                    <div id="valideNom" class="invalid-feedback">
                      Svp veuillez renseigner le nom de l'acteur.
                    </div>
                  </Col>
                  <Col md="8">
                    <label>Prénom(s)</label>
                    <Input
                      onChange={this.handleErrorPrenom}
                      className="form-control is-invalid"
                      type="text"
                      id="prenom"
                      placeholder="Prénom"
                    />
                    <div id="validePrenom" class="invalid-feedback">
                      Svp veuillez renseigner le prénom de l'acteur.
                    </div>
                  </Col>
                  
              </Row>:null
            }

              <Row className="mt-4">
                <Col md="4">
                  <label>Adresse email</label> 
                  <Input
                    onChange={this.handleErrorEmail}
                    className="form-control is-invalid"
                    type="email"
                    id="email"
                    placeholder="Adresse email"
                  />
                  <div id="valideEmail" class="invalid-feedback">
                    Svp veuillez renseigner une adresse mail valide.
                  </div>
                </Col>
                <Col md="4">
                  <label>Numéro de téléphone</label> 
                  <Input
                    className="form-control"
                    type="telephone"
                    id="telephone"
                    placeholder="Numéro de téléphone"
                  />
                </Col>
            
                  {/* { this.state.personalite? */}
                    <Col md="4">
                      <label>Adresse</label>
                      <Input
                        // onChange={this.handleErrorAdresse}
                        className="form-control"
                        type="text"
                        id="adresse"
                        placeholder="Adresse"
                      />
                      {/* <div id="valideAdresse" class="invalid-feedback">
                        Svp veuillez renseigner l'adresse de l'acteur.
                      </div> */}
                    </Col>
                  {/* } */}
              </Row>
        

              

              </CardBody>
            </Card>

            <Card style={{borderRadius:"25px",borderColor:"#AAD29A",borderWidth:"5px"}}>
              <CardBody>
              <h4 className="text-center mt-2">Spécialités de l'acteur</h4>
              <hr/>
              <Row className="mt-4">
              <Col md="6">
                  <label>Type d'acteur</label> 
                  <select onChange={this.handleErrorTypeExpert} className="form-select is-invalid" aria-label="Default select example" id="type_expert_id">
                        <option value="0" selected>Choisir le type d'acteur</option>
                        {
                          this.state.type_expert.map((element,idx) =>(
                            <option value={element.value}>{element.label}</option>
                          ))
                        }
                  </select>
                  <div id="valideTypeExpert" class="invalid-feedback">
                    Svp veuillez choisir le type d'acteur.
                  </div>
              </Col>
              {
                this.state.sous_type_expert.length?
              <Col md="6">
                  <label>Sous type(s) d'acteur(s) associé(s)</label>
                  <ReactSelect
                    closeMenuOnSelect={false}
                    components={animatedComponents}
                    isMulti
                    onChange={this.handleChangeSousTypeExpert}
                    options={this.state.sous_type_expert}
                    placeholder="Choisir le/les sous type(s) d'acteur(s) associé(s)"
                  />
                </Col>:null
               }
              </Row>
              <Row className="mt-4"> 
                <Col md="6">
                  <label>Type(s) de système(s) d'irrigation</label>
                  <ReactSelect
                    closeMenuOnSelect={false}
                    components={animatedComponents}
                    isMulti
                    onChange={this.handleChangeSysteme}
                    options={this.state.irrigue}
                    placeholder="Choisir le/les type(s) de système d'irrigation"
                  />
                </Col>
                <Col md="6">
                  <label>Thématique(s)</label>
                  <ReactSelect
                    closeMenuOnSelect={false}
                    components={animatedComponents}
                    isMulti
                     onChange={this.handleChangeThematique}
                     options={this.state.thematique}
                    placeholder="Choisir la/les thématique(s)"
                  />
                </Col>
              </Row>

              <Row className="mt-4"> 
                <Col md="6">
                  <label>Pays</label>
                  <ReactSelect
                    closeMenuOnSelect={false}
                    components={animatedComponents}
                    isMulti
                    onChange={this.handleChangeLocalisation}
                    options={this.state.localisation}
                    placeholder="Choisir le/les pays"
                  />
                </Col>
                <Col md="6">
                  <label>Langue(s)</label>
                  <ReactSelect
                    closeMenuOnSelect={false}
                    components={animatedComponents}
                    isMulti
                     onChange={this.handleChangeLangue}
                     options={this.state.langue}
                    placeholder="Choisir le/les Langue(s)"
                  />
                </Col>
              </Row>
                {/* { this.state.personalite?
                  <Row className="mt-4">
                    <Col md="6">
                        <label>Structure</label> 
                        <select  className="form-select" aria-label="Default select example" id="structure_id">
                              <option value="0" selected>Choisir la structure</option>
                              {
                                this.state.structure.map((element,idx) =>(
                                  <option value={element.value}>{element.label}</option>
                                ))
                              }
                        </select>
                    </Col>
                  </Row>:null
                } */}
              </CardBody>
            </Card>

            <Row className="mt-4 mb-2 text-center justify-content-center">
              {/* <div
                id="profile"
                data-toggle="tooltip" 
                data-placement="top" 
                data-html="true"
                title="Cochez la caase si vous voulez attibuer un compte à cet acteur"
              >
              </div> */}
              <Col md="10">
                <h4><strong>Veuillez cocher cette case si vous voulez attribuer un compte à cet acteur  --{">"} </strong></h4>
              </Col>
              <Col md="2">
                <Input
                  className="form-control chbx pull-left"
                  type="checkbox"
                  id="chbx"
                  onChange={this.onChangeBlocAcces}
                />
              </Col>
            </Row> 

       {
         this.state.block_acces?
            <Card style={{borderRadius:"25px",borderColor:"#AAD29A",borderWidth:"5px"}}>
              <CardBody>
              <h4 className="text-center mt-2">Compte de l'acteur</h4>
                <hr/>
                <Row className="mt-4"> 
                  <Col md="6">
                    <label>Mot de passe</label>
                    <Input
                      className="form-control"
                      type="password"
                      id="pwd1"
                      placeholder="Mot de passe"
                    />
                  </Col>
                  <Col md="6">
                    <label>Répetez le mot de passe</label>
                    <Input
                      className="form-control"
                      type="password"
                      id="pwd2"
                      placeholder="Répetez le mot de passe"
                    />
                  </Col>
                </Row>
                <Row className="mt-4"> 
                  <Col md="6">
                    <label>Statut du compte</label>
                    <select className="form-select" 
                      // onClick={this.handleChangeAcces} 
                      aria-label="Default select example" id="statut"
                    >
                      <option selected value="DESACTIVE">Compte désactivé</option>
                      <option value="ACTIVE">Compte activé</option>
                    </select>
                  </Col> 
                 </Row>
                <hr></hr>

              </CardBody>
            </Card>:null
       }
                

            <Row className="justify-content-start mt-3 ">
              <Col md="3"></Col>
              <Col md="6">
              <div style={{textAlign:"center"}}>
                <div id="echecSauv" className="alert alert-danger mt-2" role="alert">
                    {this.state.message}
                </div>
              </div>
              </Col>
              <Col md="3"></Col>
            </Row> 

            <hr></hr>

            <Row className="justify-content-start mt-5 mb-5">
              <Col md="6">
                <Button style={{backgroundColor:"#aad29a", borderColor:"#aad29a",float:"right",borderRadius:"10px"}} id="initial" color="success"

                  onClick={this.handleCreer}
                >
                  Ajouter l'acteur
                </Button>
                
                <Button style={{float:"right",borderRadius:"10px"}} id="chargement" color="info" className="b-lg" type="button" disabled>
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"> </span>
                Ajout de l'expert...
                </Button>

              </Col>

              <Col md="6">
                <Button  style={{backgroundColor:"#6A7172",float:"left",borderRadius:"10px"}}  color="secondary" onClick={this.handleAnnuler}>
                  Annuler
                </Button>
              </Col>
            </Row>
            {/* 
            <Row className="justify-content-start mt-5 mb-5">
              <Col md="3"></Col>
              <Col md="6">
              <div style={{textAlign:"center"}}>
                <div id="echecSave" className="alert alert-danger mt-2" role="alert">
                    {this.state.message}
                </div>
              </div>
              </Col>
              <Col md="3"></Col>
            </Row>  */}
          </Container>
          </div>
          
      </React.Fragment>
    )
  }

}
export default AjoutExpert